module.exports = __webpack_public_path__ + "static/media/fly0229.e8640b5c.webp";